<template>
  <transition name="modal">
    <div class="ui-modal overlay component" v-if="show" @click="onClickOverlay" ref="overlay">
      <div
        v-bind:style="{ width: width + 'px', height: height ? height + 'px' : 'auto' }"
        class="modal-content"
      >
        <div class="header">
          <h3 class="title">{{ title }}</h3>
          <button class="close" @click="close" v-if="showCloseButton"></button>
        </div>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SfWarningModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: false
    },
    width: Number,
    title: String,
    height: Number
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },
    onClickOverlay($event) {
      if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-modal.overlay.component {
  width: 100vw;
  height: 100vh;
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  .modal-content {
    background-color: #fff;
    box-shadow: 0 7px 20px rgba(0, 0, 0, 0.5);
    border-radius: 0;
    border: 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    width: 480px;
    .header {
      display: flex;
      align-items: center;
      padding: 16px;
      border-radius: 0;
      height: auto !important;
      background-color: #ffc107 !important;
      h3 {
        color: #fff;
        font-weight: 600;
      }
      .close {
        width: 16px;
        height: 16px;
        background-image: url('../assets/images/cancel-icon.svg');
        background-repeat: no-repeat;
        background-position: center;
        justify-self: flex-end;
        position: absolute;
        right: 16px;
        opacity: 1;
      }
    }
  }
}

/* modal transition */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}
.modal-enter,
.modal-leave-to {
  padding-top: 100px;
  opacity: 0;
}
</style>
